import Api from 'utils/ApiRequest'
import API_TOTEM from 'constants/api'
import {
  FETCH_TOTEM_REPORTS_REQUEST,
  FETCH_TOTEM_REPORTS_SUCCESS,
  FETCH_TOTEM_REPORTS_ERROR,
  FETCH_TOTEM_REPORTS_CANCEL,
  FETCH_TOTEM_REPORTS_CSV_REQUEST,
  FETCH_TOTEM_REPORTS_CSV_SUCCESS,
  FETCH_TOTEM_REPORTS_CSV_ERROR,
  FETCH_TOTEM_REPORTS_CSV_CANCEL,
} from 'actionTypes'
import { showSpinner, hideSpinner } from 'action/spinner'

/**
 * Nome do arquivo CSV para download, alinhado ao backend (ReportCsvService.getFileName).
 * @param {{ queueReportType?: string, store?: string, date?: string, exclusionReason?: string }} filters
 * @returns {string} nome do arquivo sem extensão (ex.: "pedidos-por-loja-modal")
 */
function getTotemReportCsvFilename(filters) {
  const type = filters?.queueReportType || ''
  const hasStore = filters?.store != null && String(filters.store).trim() !== ''
  const hasDate = filters?.date != null && String(filters.date).trim() !== ''
  const hasExclusionReason = filters?.exclusionReason != null && String(filters.exclusionReason).trim() !== ''

  switch (type) {
    case 'ORDERS_BY_STORE':
      return hasStore ? 'totem-pedidos-por-loja-modal' : 'totem-pedidos-por-loja-geral'
    case 'ORDERS_BY_DAY':
      return hasDate ? 'totem-quantidade-pedidos-por-dia-modal' : 'totem-quantidade-pedidos-por-dia-geral'
    case 'AVERAGE_TIME_PER_DAY':
      return hasDate ? 'totem-tempo-medio-por-dia-modal' : 'totem-tempo-medio-por-dia-geral'
    case 'REASONS_FOR_DELETING_MONITOR_ORDERS':
      return hasExclusionReason ? 'totem-motivos-exclusao-modal' : 'totem-motivos-exclusao-geral'
    case 'QUANTITY_OF_ORDER':
      return 'totem-qtd-de-pedidos'
    case 'AVERAGE_TIME':
      return 'totem-tempo-medio'
    case 'ORDERS_UNDER_10_MIN':
      return 'totem-pedidos-abaixo-de-cinco-min'
    case 'ORDERS_OVER_10_MIN':
      return 'totem-pedidos-acima-de-cinco-min'
    default:
      return 'totem'
  }
}
export const fetchTotemReports = (token, filters) => (dispatch) => {
  dispatch(fetchTotemReportsRequest())
  dispatch(showSpinner())

  return new Api(token, dispatch)
    .post(API_TOTEM.TOTEM_FILTER_REPORTS_NEW, filters)
    .then(
      async (response) => {
        await processResponse(token, response, dispatch)
      },
      async (error) => {
        fetchTotemReportsError(error, dispatch)
        dispatch(hideSpinner())
      }
    )
}

export const fetchTotemReportsFlux = (branchToken, token, filters,signalController) => (dispatch) => {
  dispatch(fetchTotemReportsRequest())

    
    const onError = (error) => {
      fetchTotemReportsError(error, dispatch)
      dispatch(hideSpinner())
    }
  
    const onMessage = async (response) => {
      await processResponse(branchToken,response, dispatch)
    }

    const onClose = () => {
      dispatch(hideSpinner())
      dispatch(hideSpinner())
    }
  
    const abort = () => {
      signalController.abort()
      dispatch(hideSpinner())
      dispatch(hideSpinner())
    }

    dispatch(showSpinner("", true, abort))

    return new Api(token, dispatch, null, true)
      .eventSourceStream(API_TOTEM.TOTEM_FILTER_REPORTS_NEW_FLUX, filters, null, signalController, onMessage, onClose, onError)
      .catch((error) => {
        if (error?.status === 401 || error?.status === 403) {
          dispatch(hideSpinner())
          throw error
        }
        onError(error)
      })
}

export const fetchTotemReportsCsvFlux = (token, filters, signalController) => (dispatch) => {
  dispatch(fetchTotemReportsCSVRequest());

  const onError = (error) => {
    dispatch(fetchTotemReportsCsvCancel());
    dispatch(hideSpinner());

    const errorMessage = error.message || "An unknown error occurred.";
    dispatch({
      type: FETCH_TOTEM_REPORTS_CSV_ERROR,
      payload: errorMessage
    });
  };

  let csvFile = "";

  const onMessage = async (response) => {
    if (response.cdStatus === 500) {
      throw new Error("Server error occurred while generating the report.");
    }

    const chunk = response.data !== undefined && response.data !== false ? String(response.data) : "";
    csvFile += chunk;

    // Validação: inspecionar o que o backend envia (útil para debug do download)
    if (process.env.NODE_ENV === "development" && chunk) {
      console.log("[totem-reports CSV] Chunk recebido:", chunk.length, "chars. Preview:", chunk.slice(0, 120));
    }
  };

  const onClose = () => {
    dispatch(hideSpinner());

    if (csvFile) {
      // Detecta se o conteúdo é mensagem de erro do backend (ex.: "C:\totem.csv (Acesso negado)")
      const looksLikeCsv = csvFile.includes(";") || csvFile.trim().startsWith("\uFEFF");
      const looksLikeError = /Acesso negado|Access denied|C:\\/.test(csvFile) || (!looksLikeCsv && csvFile.length < 500);

      if (looksLikeError && !looksLikeCsv) {
        console.warn("[totem-reports CSV] Resposta parece ser erro do servidor, não CSV. Conteúdo recebido:", csvFile.slice(0, 200));
        dispatch({
          type: FETCH_TOTEM_REPORTS_CSV_ERROR,
          payload: `Erro ao gerar CSV no servidor. O backend pode estar tentando gravar em disco sem permissão. Detalhe: ${csvFile.slice(0, 150)}`,
        });
        return;
      }

      dispatch({ type: FETCH_TOTEM_REPORTS_CSV_SUCCESS, payload: csvFile });

      const filename = `${getTotemReportCsvFilename(filters)  }.csv`;
      const blob = new Blob([csvFile], { type: "text/csv;charset=utf-8;" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const abort = () => {
    signalController.abort()
    dispatch(hideSpinner())
    dispatch(hideSpinner())
  };

  dispatch(showSpinner("", true, abort));

  return new Api(token, dispatch, null, true)
    .eventSourceStream(API_TOTEM.TOTEM_FILTER_REPORTS_CSV_NEW_FLUX, filters, null, signalController, onMessage, onClose, onError)
    .catch((error) => {
      if (error?.status === 401 || error?.status === 403) {
        dispatch(hideSpinner())
        throw error
      }
      onError(error)
    })
};

export const fetchTotemReportsCSVRequest = () => ({
  type: FETCH_TOTEM_REPORTS_CSV_REQUEST,
})

export const fetchTotemReportsCsvCancel = () => ({
  type: FETCH_TOTEM_REPORTS_CSV_CANCEL,
});

export const fetchTotemReportsRequest = () => ({
  type: FETCH_TOTEM_REPORTS_REQUEST,
})

export const fetchTotemReportsCancel = () => ({
  type: FETCH_TOTEM_REPORTS_CANCEL,
})

export const fetchTotemReportsSuccess = (data, dispatch) => {
  dispatch(reportsSuccess(data))
}

const reportsSuccess = (data) => ({
  type: FETCH_TOTEM_REPORTS_SUCCESS,
  payload: data,
})

export const fetchTotemReportsError = (error, dispatch) => {
  dispatch(reportsError(error))
}

export const reportsError = (error) => ({
  type: FETCH_TOTEM_REPORTS_ERROR,
  payload: error,
})
async function processResponse(token, response, dispatch) {
  const { data } = await new Api(token).post(API_TOTEM.BRANCHES)
  const regionCompanies = []
  const companyOptions = []

  data.map((company) => {
    if (regionCompanies[company.idRegion] === undefined) {
      regionCompanies[company.idRegion] = []
      regionCompanies[company.idRegion].idRegion = company.idRegion
      regionCompanies[company.idRegion].dsRegion = company.dsRegion
      regionCompanies[company.idRegion].branches = []
    }
    regionCompanies[company.idRegion].branches.push(company)
  })

  regionCompanies.sort((a, b) => (a.dsRegion > b.dsRegion ? 1 : -1))

  regionCompanies.map((region) => {
    companyOptions.push({
      value: region.idRegion,
      label: region.dsRegion,
      visible: true,
    })
    region.branches.map((branch) => {
      companyOptions.push({
        value: branch.id,
        label: `${branch.id} - ${branch.name} `,
        isBranch: true,
        idRegion: branch.idRegion,
        visible: true,
      })
      return branch
    })
    return region
  })

  fetchTotemReportsSuccess(
    response.data.map((report) => ({
      ...report,
      store: companyOptions.find(
        (option) => option.value === report.store
      ).label,
    })),
    dispatch
  )
  dispatch(hideSpinner())
}

